<template>
  <div class="VIncrement flex items-center">
    <v-button
      color="is-orange"
      size="xs"
      type="button"
      @click="decrement"
    ><i class="mps mps-minus"/></v-button>
    <div class="px-4 font-bold">
      {{ computedValue }}
    </div>
    <v-button
      color="is-orange"
      size="xs"
      type="button"
      @click="increment"
    ><i class="mps mps-plus"/></v-button>
  </div>
</template>

<script>
/**
 * @module VIncrement
 */
export default {
  name: 'VIncrement',

  props: {
    value: {
      type: Number,
      required: true
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: null
    }
  },

  computed: {
    computedValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {
    increment () {
      if (this.max !== null && this.max < this.computedValue + 1) return this.$emit('over')
      this.computedValue = this.computedValue + 1
    },
    decrement () {
      if (this.min > this.computedValue - 1) return this.$emit('under')
      this.computedValue = this.computedValue - 1
    }
  }
}
</script>

<style rel='stylesheet/scss' lang='scss'>
@import '~utils';

</style>
